import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import { ParticleWaveBackground } from '../lib/ParticleWaveBackground';

export function initRequestSentBook(parent) {
  if (!parent) return;

  const animationTopRightEl = parent.querySelector(
    '.request-sent-book__animation-top-right',
  );

  if (animationTopRightEl) {
    const animationTopRight = new ParticleWaveBackground(animationTopRightEl, {
      planeWidth: 6,
      planeHeight: 12,
      widthSegments: 80,
      heightSegments: 120,
      particleSize: 0.04,
      waveHeight: 0.3,
      noiseScale: 3,
      animationSpeed: 8000,
      gradient: [
        { color: '#851E07', stop: 0 },
        { color: '#00000000', stop: 100 },
      ],
      rotation: { x: -0.6, y: 0.09, z: -2.2 },
      cameraPosition: [-2, -2.6, 8.4],
      cameraRotation: { x: 0, y: 0, z: 0 },
      autoStart: false,
      hoverRadius: 1,
      hoverStrength: 0.5,
      hoverSpringStiffness: 40,
      hoverSpringDamping: 10,
      breakpoints: {
        [1024]: {
          particleSize: 0.025,
        },
      },
    });

    ScrollTrigger.create({
      trigger: parent,
      start: 'top bottom',
      end: 'bottom top',
      onEnter: () => {
        animationTopRight.startAnimation();
      },
      onLeave: () => {
        animationTopRight.stopAnimation();
      },
      onEnterBack: () => {
        animationTopRight.startAnimation();
      },
      onLeaveBack: () => {
        animationTopRight.stopAnimation();
      },
    });
  }

  const features = parent.querySelector('.request-sent-book__features');
  const items = parent.querySelectorAll('.request-sent-book__feature');

  if (!features || !items.length) return;

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: features,
      start: 'top 75%',
      toggleActions: 'play none none none',
    },
    defaults: { ease: 'power2.out' },
  });

  items.forEach((item, index) => {
    const icon = item.querySelector('.request-sent-book__feature-icon');
    const copy = item.querySelector('p');
    const position = index === 0 ? 0 : '>-0.40';

    if (icon) {
      tl.from(
        icon,
        {
          opacity: 0,
          scale: 0.9,
          y: 10,
          rotation: -10,
          filter: 'blur(2px)',
          duration: 0.6,
          ease: 'power2.out',
          clearProps: 'filter',
        },
        position,
      );
    }

    if (copy) {
      tl.fromTo(
        copy,
        {
          opacity: 0,
          y: 10,
          filter: 'blur(2px)',
          clipPath: 'polygon(0% 0%, 0% 0%, 0% 100%, 0% 100%)',
        },
        {
          opacity: 1,
          y: 0,
          filter: 'blur(0px)',
          clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
          duration: 0.7,
          ease: 'power2.out',
          clearProps: 'filter',
        },
        '<0.04',
      );
    }
  });
}

export function initAllRequestSentBooks(selector = '.js-request-sent-book') {
  const blocks = document.querySelectorAll(selector);
  blocks.forEach((block) => initRequestSentBook(block));
}
